import axios from 'axios'
// 上传图片
export function Upimg(data) {
  return axios({
    url: 'https://storage.haiwojiamei.com/api/meijia/upload',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data; boundary=----WebKitFormBoundaryyJm0uSCZpejQDoIK',
      'Accept': '*/*',
      'X-requested-with':'XMLHttpRequest'
    },
    data
  })
}
